import React, { useState } from "react";
import SignedAudioPlayer from "./SignedAudioPlayer";
import { useSelector, useDispatch } from "react-redux";
import { Box, Typography, Stack, Drawer, Collapse, IconButton } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { classes } from "./MessageList";
import three_dots from "../../../assets/images/chats/three_dots.svg";
import starred_icon from "../../../assets/images/chats/starred_icon.svg";
import unstar_icon from "../../../assets/images/chats/unstar_icon.svg";
import replaym from "../../../assets/images/chats/reply.svg";
import moment from "moment";
import MoreMenu from "./MoreMenu";
import InputDialogComponent from "../../../components/InputDialog";
import PersonIcon from "../../../assets/images/chats/person.svg";
import FolderIcon from "../../../assets/images/chats/FolderIcon.svg";
import RecipientList from "./RecipientList";
import { getFileIconUrl, handleOpenFile, isGoogleYoutubeUrl } from "../../../utils/findextension";
import { handleMediaDownload } from "../../../appStore/actions/ArkchatGroup/action";
import {
  AccountLevelArkchatPermission,
  ApprovalStatus,
  MessageType,
  TaskStatus,
  priorityValueColor,
  priorityValueLable,
} from "../../../utils/constant";
import StartTask from "./StartTask";
import { useTranslation } from "react-i18next";
import HandleLink from "./HandleLink";
import {
  colorSchemes,
  personIconStyle,
} from "../../../assets/commonFunction";
import TaskStatusButton from "../../../components/TaskStatusButton/TaskStatusButton";
import session, { showUpdateTaskButton } from "../../../utils/helper";
import useAppSelectors from "../../../customHooks/useAppSelectors";
const MessageThread = ({
  item,
  isMoreMenuOpen,
  startTaskOpen,
  setStartTaskOpen,
  handleStartTask,
  threeDotRef,
  isDeleteGroupMsgOpenIndicatorId,
  isDeleteGroupMsgOpen,
  handleReadStatusDrawer,
  setisTopicOpen,
  setMoveTopicMsgId,
  setMoveTopicTriggered,
  setDeleteGroupMsgOpenIndicatorId,
  setDeleteGroupMsgOpen,
  handlegetThreadMessages,
  setMoreMenu,
  menuRef,
  toggleItemMenu,
  localStarMsgData,
  handleStarUnstarMsg,
  handleDeleteGrpMsg,
  setDeleteGrpMsgType,
  handleClickTaskUpdate,
  handleShowUserProfile,
  bgcolor,
  scrollToRepliedMessage,
  hideBottonLine = false,
  onPreviewFile,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });

  const { selectedGroup, groupTopicData, groupSubtopicData, groupRecipientDetails, currentUserData} = useAppSelectors();
  const threadMsgList = useSelector((state) => state?.arkchatgroup?.threadMsgList);
  const parentThread = threadMsgList?.find((m) => !m?.thread_id) || null;
  const threadNumber = item?.thread_id ? parentThread?.thread_number : item?.thread_number;
  const threadHeading = item?.thread_id ? parentThread?.thread_heading : item?.thread_heading;
  const [isRecipientListOpen, setRecipientListOpen] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [recipientList, setRecipientList] = useState([]);
  const isThreadScreen = session.get("isThreadScreen");

  const handleSeeRecipientList = (recipientData) => {
    setRecipientList(recipientData);
    setRecipientListOpen(true);
  };
  return (
    <>
      <Drawer
        sx={{
          zIndex: 12011,
        }}
        hideBackdrop={true}
        anchor={"right"}
        open={isRecipientListOpen}
      >
        <RecipientList
          recipientList={recipientList}
          readby={item?.read_by}
          setRecipientListOpen={setRecipientListOpen}
          handleShowUserProfile={handleShowUserProfile}
        />
      </Drawer>
      <Box
        key={item?.timetoken}
        px={"6px"}
        mb={"6px"}
        position="relative"
        sx={{ zIndex: isMoreMenuOpen?.timetoken === item?.timetoken ? 100 : "auto" }}
      >
        <Box
          width={"100%"}
          bgcolor={bgcolor === "transparent" ? "#FFFFFF" : bgcolor}
          borderRadius={"8px"}
          border={"1px solid #ECECEC"}
        >
          {(item?.type === 0 ||
            item?.type === 3 ||
            item?.type === 1 ||
            item?.type === 2) && (
            <>
              <Stack
                direction="row"
                width={"100%"}
                padding={"0.8rem"}
                justifyContent={"space-between"}
                id={`replied-message-${item?.temp_timetoken}`}
              >
                <div style={{ width: "100%" }}>
                  <Stack
                    width={"100%"}
                    direction="row"
                    spacing={1}
                  >
                    {/* ------------profile section--------------- */}
                    {item?.from?.pp ? (
                      <Box
                        onClick={() => handleShowUserProfile(item?.from?.id)}
                        sx={{ ...classes.chatUserprofile, cursor: "pointer" }}
                      >
                        <img src={item?.from?.pp} alt="profile" height="100%" />
                      </Box>
                    ) : (
                      <Box
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleShowUserProfile(item?.from?.id)}
                        bgcolor={"#E3E1E1"}
                        width={"30px"}
                        height={"30px"}
                        display={"flex"}
                        flex={"none"}
                        alignItems={"center"}
                        flex-wrap={"wrap"}
                        justifyContent={"center"}
                        borderRadius={"0.15rem"}
                        // border={"1px solid blue"}
                      >
                        <img
                          style={personIconStyle}
                          src={PersonIcon}
                          alt="individual"
                        />
                        {/* <Typography variant="h6" fontSize={"0.75rem"}>
                          {item?.from?.name && item?.from?.name[0]}
                        </Typography> */}
                      </Box>
                    )}
                    {/* ------------Details section--------------- */}
                    <Box width={"100%"} paddingRight={2}>
                      <Stack
                        direction="row"
                        spacing={1}
                        width={"100%"}
                        justifyContent={"space-between"}
                      >
                        <Box
                          sx={{ width: "89%", display: "flex" }}
                        >
                          <Typography variant="subtitle2" fontWeight={"450"}>
                            {item?.from?.name}
                          </Typography>
                          <Typography
                            sx={{ ...classes.duetime, marginLeft: "0.5rem" }}
                          >
                            {/* Time */}
                            {moment(Math.floor(item?.timetoken / 10000)).format(
                              currentUserData?.timeFormat === "24"
                                ? currentUserData
                                    ?.userDateTimeFormat
                                : currentUserData
                                    ?.userDateTimeFormat
                            )}
                          </Typography>
                        </Box>
                        {/* ------------Right section--------------- */}
                        <Box>
                          <Stack
                            spacing={2}
                            direction="row"
                            alignItems={"center"}
                          >
                            <Box position={"relative"}>
                              <Box
                                ref={threeDotRef}
                                onClick={() => toggleItemMenu(item)}
                                sx={{
                                  cursor: "pointer",
                                  pointerEvents: isMoreMenuOpen ? "none" : "",
                                }}
                              >
                                <img src={three_dots} alt="more" />
                              </Box>
                              {isMoreMenuOpen?.timetoken ===
                                item?.timetoken && (
                                <MoreMenu
                                  selectedGroup={selectedGroup}
                                  isThreadScreen={isThreadScreen}
                                  menuRef={menuRef}
                                  messageData={item}
                                  setMoreMenu={setMoreMenu}
                                  isStarred={item?.isStarred}
                                  handleReplyMessage={handlegetThreadMessages}
                                  setDeleteGroupMsgOpen={setDeleteGroupMsgOpen}
                                  setDeleteGroupMsgOpenIndicatorId={
                                    setDeleteGroupMsgOpenIndicatorId
                                  }
                                  setMoveTopicTriggered={setMoveTopicTriggered}
                                  setMoveTopicMsgId={setMoveTopicMsgId}
                                  setisTopicOpen={setisTopicOpen}
                                  handleReadStatusDrawer={
                                    handleReadStatusDrawer
                                  }
                                />
                              )}
                              <>
                                {isDeleteGroupMsgOpen &&
                                  isDeleteGroupMsgOpenIndicatorId ===
                                    item?.timetoken && (
                                    <InputDialogComponent
                                      title="Delete"
                                      isType="deletegroupmessage"
                                      open={isDeleteGroupMsgOpen}
                                      handleClose={() => {
                                        setDeleteGroupMsgOpen(false);
                                        setDeleteGroupMsgOpenIndicatorId(null);
                                      }}
                                      btnLabel="Delete"
                                      setDeleteGrpMsgType={setDeleteGrpMsgType}
                                      onClick={() => handleDeleteGrpMsg(item)}
                                      isallowedDeleteGrpMsgForall={
                                        (currentUserData?.id ===
                                          item?.from?.id ||
                                          currentUserData
                                            ?.activePermission ===
                                            AccountLevelArkchatPermission?.ADMIN) &&
                                        moment().diff(
                                          Math.floor(item?.timetoken / 10000),
                                          "minutes"
                                        ) <= 30
                                          ? false
                                          : true
                                      }
                                    />
                                  )}
                              </>
                            </Box>

                            <Box
                              onClick={() =>
                                handleStarUnstarMsg(
                                  item?.timetoken,
                                  item?.starred_by
                                )
                              }
                              sx={{
                                cursor: "pointer",
                                width: "16px",
                              }}
                            >
                              <img
                                width={"100%"}
                                height={"100%"}
                                src={
                                  (item?.starred_by &&
                                    item?.starred_by?.includes(
                                      currentUserData?.id
                                    )) ||
                                  localStarMsgData?.includes(item?.timetoken)
                                    ? starred_icon
                                    : unstar_icon
                                }
                                alt="more"
                              />
                            </Box>
                          </Stack>
                        </Box>
                        {/* ------------------------------------------ */}

                        {/* <Box sx={classes.tick}>
                        <img src={tick_gray} alt="Chat Status" />
                      </Box> */}
                      </Stack>
                      <Typography
                        onClick={() => handleSeeRecipientList(item?.to)}
                        variant="subtitle2"
                        display={"inline-block"}
                        sx={classes.userlink}
                      >
                        {item?.is_all_group_member
                          ? "To all group members"
                          : `To ${item?.to[0]?.name}${
                              item?.to?.length > 1
                                ? `, and ${item?.to?.length - 1} more`
                                : ""
                            }`}
                      </Typography>

                      {/* -------------reply---------- */}
                      {item?.thread_original_message &&
                        item?.translations &&
                        item?.thread_original_message?.translations && (
                          <Stack
                            direction="row"
                            width={"100%"}
                            spacing={1}
                            sx={{ ...classes.chatRep, cursor: "pointer" }}
                            onClick={() =>
                              scrollToRepliedMessage(
                                item?.thread_original_message?.temp_timetoken
                              )
                            }
                          >
                            <img
                              src={replaym}
                              alt="reply"
                              style={{
                                width: "18px",
                                height: "12px",
                                flexShrink: 0,
                                alignSelf: "center",
                              }}
                            />
                            {item?.translations &&
                            item?.thread_original_message?.translations[
                              item?.to?.find(
                                (data) =>
                                  data?.id === currentUserData?.id
                              )?.languageCode
                            ] ? (
                              <Typography
                                variant="body2"
                                sx={{
                                  wordWrap: "break-word",
                                }}
                              >
                                {item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1 &&
                                  item?.thread_original_message?.translations[
                                    item?.to?.find(
                                      (data) =>
                                        data?.id ===
                                        currentUserData?.id
                                    )?.languageCode
                                  ]?.slice(0, 200) + " ..."}
                              </Typography>
                            ) : (
                              <Typography
                                variant="body2"
                                sx={{
                                  wordWrap: "break-word",
                                }}
                              >
                                {item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1 &&
                                  item?.thread_original_message?.message?.slice(
                                    0,
                                    200
                                  ) + " ..."}
                              </Typography>
                            )}
                          </Stack>
                        )}

                      {/* text message */}
                      <Box width={"100%"}>
                        <HandleLink>
                          {item?.translations &&
                          item?.translations[
                            item?.to?.find(
                              (data) =>
                                data?.id === currentUserData?.id
                            )?.languageCode
                          ] ? (
                            <Typography
                              sx={{ wordWrap: "break-word" }}
                              width={"100%"}
                              variant="body2"
                            >
                              {!expanded &&
                                item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1 &&
                                item?.translations[
                                  item?.to?.find(
                                    (data) =>
                                      data?.id ===
                                      currentUserData?.id
                                  )?.languageCode
                                ]
                                  ?.slice(0, 200)
                                  ?.split(/\n/)
                                  ?.map((line, indx) => (
                                    <span
                                      key={line + indx + "xyz007"}
                                      style={{
                                        marginBottom: "0.5rem",
                                        display: "block",
                                        border:
                                          line === ""
                                            ? "1px solid transparent"
                                            : "none",
                                      }}
                                    >
                                      <>{line === "" ? " " : line}</>
                                    </span>
                                  ))}{" "}
                              {!expanded &&
                              item?.translations[
                                item?.to?.find(
                                  (data) =>
                                    data?.id === currentUserData?.id
                                )?.languageCode
                              ]?.length > 200
                                ? " ..."
                                : ""}
                              <Collapse
                                sx={{ wordWrap: "break-word" }}
                                in={expanded}
                                timeout="auto"
                                unmountOnExit
                              >
                                {item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== -1 &&
                                  item?.translations[
                                    item?.to?.find(
                                      (data) =>
                                        data?.id ===
                                        currentUserData?.id
                                    )?.languageCode
                                  ]
                                    ?.split(/\n/)
                                    ?.map((line, indx) => (
                                      <span
                                        key={line + indx + "xyz008"}
                                        style={{
                                          marginBottom: "0.5rem",
                                          display: "block",
                                          border:
                                            line === ""
                                              ? "1px solid transparent"
                                              : "none",
                                        }}
                                      >
                                        <>{line === "" ? " " : line}</>
                                      </span>
                                    ))}
                              </Collapse>
                              {item?.translations[
                                item?.to?.find(
                                  (data) =>
                                    data?.id === currentUserData?.id
                                )?.languageCode
                              ]?.length > 200 && (
                                <Typography
                                  variant="body2"
                                  width={"100%"}
                                  expand={expanded}
                                  onClick={() => setExpanded(!expanded)}
                                  aria-expanded={expanded}
                                  aria-label="show more"
                                  sx={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  display={"inline"}
                                  color={"#2C86FF"}
                                >
                                  {expanded ? "less" : "more"}
                                </Typography>
                              )}
                            </Typography>
                          ) : (
                            <Typography
                              sx={{ wordWrap: "break-word" }}
                              width={"100%"}
                              variant="body2"
                            >
                              {!expanded &&
                                item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== 1 &&
                                item?.message?.slice(0, 200) +
                                  (item?.message?.length > 200 ? " ..." : "")}
                              <Collapse
                                in={expanded}
                                timeout="auto"
                                unmountOnExit
                              >
                                {item?.to?.findIndex(
                                  (idData) =>
                                    idData?.id ===
                                    currentUserData?.id
                                ) !== 1 &&
                                  item?.message
                                    ?.split(/\n/)
                                    .map((line, indx) => (
                                      <span
                                        key={line + indx + "xyz009"}
                                        style={{
                                          marginBottom: "0.5rem",
                                          display: "block",
                                          border:
                                            line === ""
                                              ? "1px solid transparent"
                                              : "none",
                                        }}
                                      >
                                        {line}
                                      </span>
                                    ))}
                              </Collapse>

                              {item?.message?.length > 200 && (
                                <Typography
                                  variant="body2"
                                  width={"100%"}
                                  expand={expanded}
                                  onClick={() => setExpanded(!expanded)}
                                  aria-expanded={expanded}
                                  aria-label="show more"
                                  sx={{
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                  }}
                                  display={"inline"}
                                  color={"#2C86FF"}
                                >
                                  {expanded ? "less" : "more"}
                                </Typography>
                              )}
                            </Typography>
                          )}
                        </HandleLink>
                      </Box>
                      {/* -----------------Topic + Thread row------------------ */}
                      {(() => {
                        const subtopic = item?.subtopic_id ? (groupSubtopicData || []).find((d) => d?.id === item?.subtopic_id) : null;
                        const resolvedTopicId = item?.topic_id || subtopic?.topicId || subtopic?.topic_id || "";
                        const topicObj = groupTopicData?.data?.find((d) => d?.id === resolvedTopicId) || null;
                        const topicName = topicObj?.name || "";
                        const subtopicName = subtopic?.name || "";
                        const label = subtopicName ? `${topicName} > ${subtopicName}` : topicName;
                        return (
                          <Stack
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                            mt="0.5rem"
                          >
                            {label ? (
                              <Box
                                display="flex"
                                gap="0.3rem"
                                alignItems="center"
                                sx={{ cursor: topicObj ? "pointer" : "default", overflow: "hidden" }}
                              >
                                <img src={FolderIcon} alt="topic" style={{ width: "14px", height: "14px", flexShrink: 0 }} />
                                <Typography
                                  title={label}
                                  sx={{
                                    ...classes.userlink2,
                                    maxWidth: "160px",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {label}
                                </Typography>
                              </Box>
                            ) : (
                              <Box />
                            )}
                            <Box
                              onClick={() => handlegetThreadMessages(item, false)}
                              sx={{
                                border: "1px solid #DBDBDB",
                                borderRadius: "4px",
                                px: "0.5rem",
                                py: "0.15rem",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                flexShrink: 0,
                                minWidth: "80px",
                                maxWidth: "220px",
                              }}
                            >
                              <Typography
                                fontSize="0.75rem"
                                color="#000"
                                sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                              >
                                {threadHeading
                                  ? `# ${threadNumber} - ${threadHeading}`
                                  : `# Thread ${threadNumber ?? ""}`}
                              </Typography>
                            </Box>
                          </Stack>
                        );
                      })()}

                      {/* -----------------subUser details------------------ */}
                      {item?.type !== 0 && item?.type !== 3 && (
                        <>
                          <Box
                            sx={{
                              borderTop: "1px solid #F0F0F0",
                              mt: "0.8rem",
                              ml: "calc(-30px - 8px)",
                              mr: "-16px",
                            }}
                          />
                          <Stack
                            mt={"0.5rem"}
                            direction="row"
                            spacing={1}
                            gap={"2.5rem"}
                            width={"100%"}
                            justifyContent={"space-between"}
                            alignItems={"center"}
                          >
                            <Stack
                              width={"90%"}
                              alignItems={"center"}
                              direction="row"
                              spacing={1}
                            >
                              {item?.assignee?.pp ? (
                                <Box
                                  onClick={() =>
                                    handleShowUserProfile(item?.assignee?.id)
                                  }
                                  sx={{
                                    ...classes.chatUserprofile,
                                    cursor: "pointer",
                                  }}
                                >
                                  <img
                                    src={item?.assignee?.pp}
                                    alt="profile"
                                    height="100%"
                                  />
                                </Box>
                              ) : (
                                <Box
                                  sx={{ cursor: "pointer" }}
                                  bgcolor={"#E3E1E1"}
                                  width={"27px"}
                                  height={"27px"}
                                  display={"flex"}
                                  flex={"none"}
                                  alignItems={"center"}
                                  flex-wrap={"wrap"}
                                  justifyContent={"center"}
                                  borderRadius={"0.15rem"}
                                  onClick={() =>
                                    handleShowUserProfile(item?.assignee?.id)
                                  }
                                >
                                  <Typography variant="h6" fontSize={"0.75rem"}>
                                    {item?.assignee?.name &&
                                      item?.assignee?.name[0]}
                                  </Typography>
                                </Box>
                              )}
                              <Box>
                                <Box sx={{ ...classes.userInfo, marginTop: "0 !important" }}>
                                  <Stack
                                    direction="row"
                                    spacing={1}
                                    flexDirection={"row"}
                                    alignItems={"center"}
                                  >
                                    <Typography
                                      variant="subtitle2"
                                      fontWeight={"400"}
                                      fontSize={"0.75rem"}
                                    >
                                      {item?.type === MessageType?.Approval
                                        ? "Approval requested to"
                                        : item?.is_main ? "Task assigned to" : "Subtask assigned to"}{" "}
                                      {item?.assignee?.name}
                                    </Typography>
                                    {/* Pending Button */}
                                    <TaskStatusButton
                                      item={item}
                                      status="approval"
                                    />
                                    <TaskStatusButton
                                      item={item}
                                      status="task"
                                    />
                                  </Stack>
                                </Box>
                              </Box>
                            </Stack>
                          </Stack>

                          <Box display={"flex"}>
                            <Box
                              width="75%"
                              ml={"2.18rem"}
                              display={"flex"}
                              gap={"0.2rem"}
                              flexDirection={"column"}
                            >
                              <Typography
                                variant="subtitle2"
                                fontSize={"0.75rem"}
                                lineHeight={"15px"}
                              >
                                {item?.type === MessageType?.Approval
                                  ? appContent?.KEY343
                                  : appContent?.KEY342}{" "}
                                :{" "}
                                {moment(
                                  Math.floor(item?.timetoken / 10000)
                                ).format(
                                  currentUserData?.userDateFormat
                                )}
                              </Typography>

                              <Typography
                                variant="subtitle2"
                                lineHeight={"15px"}
                                fontSize={"0.75rem"}
                              >
                                {" "}
                                Due on :{" "}
                                {moment(item?.due_date).format(
                                  currentUserData?.userDateFormat
                                )}{" "}
                                {moment(item?.due_time, "HH:mm").format(
                                  currentUserData?.userTimeFormat
                                )}
                              </Typography>

                              <Box>
                                <Typography
                                  variant="subtitle2"
                                  fontSize={"0.75rem"}
                                  lineHeight={"15px"}
                                >
                                  {item?.type === MessageType?.Task
                                    ? "Task"
                                    : "Approval"}{" "}
                                  Priority :
                                  <span
                                    style={{
                                      display: "inline-block",
                                      width: "13px",
                                      height: "13px",
                                      verticalAlign: "middle",
                                      margin: "-1px 5px 0px 5px",
                                      backgroundColor:
                                        priorityValueColor[item?.priority],
                                    }}
                                  ></span>
                                  {priorityValueLable[item?.priority]}
                                </Typography>
                              </Box>

                              {item?.start_time > 0 && (
                                <>
                                  <Typography
                                    variant="subtitle2"
                                    fontSize={"0.75rem"}
                                    lineHeight={"15px"}
                                  >
                                    Started :{" "}
                                    {moment
                                      .unix(item?.start_time)
                                      .format(
                                        currentUserData
                                          ?.userDateFormat
                                      )}
                                  </Typography>
                                </>
                              )}

                              {item?.end_time > 0 && (
                                <>
                                  <Typography
                                    variant="subtitle2"
                                    fontSize={"0.75rem"}
                                    lineHeight={"15px"}
                                  >
                                    Finished :{" "}
                                    {moment
                                      .unix(item?.end_time)
                                      .format(
                                        currentUserData
                                          ?.userDateFormat
                                      )}
                                  </Typography>
                                </>
                              )}
                              {item?.estimated_time?.timeValue && (
                                <>
                                  <Typography
                                    variant="subtitle2"
                                    fontSize={"0.75rem"}
                                    lineHeight={"15px"}
                                  >
                                    Estimated time :{" "}
                                    {item?.estimated_time?.timeValue}{" "}
                                    {item?.estimated_time?.timeType}
                                  </Typography>

                                  {item?.actual_time?.timeValue && (
                                    <>
                                      <Typography
                                        variant="subtitle2"
                                        fontSize={"0.75rem"}
                                        lineHeight={"15px"}
                                      >
                                        Actual Time :{" "}
                                        {item?.actual_time?.timeValue}{" "}
                                        {item?.actual_time?.timeType}
                                      </Typography>
                                    </>
                                  )}
                                </>
                              )}
                              {item?.estimated_time?.timeValue && (
                                <Box>
                                  {item?.end_time > 0 && (
                                    <>
                                      <Typography
                                        color={
                                          item?.actual_time?.timeValue <
                                            item?.estimated_time?.timeValue ||
                                          Math.abs(
                                            item?.diff_time?.timeValue
                                          ) === 0
                                            ? "#007F8F"
                                            : "#DB0011"
                                        }
                                        fontSize={"0.75rem"}
                                      >
                                        {Math.abs(item?.diff_time?.timeValue) >
                                        0 ? (
                                          <>
                                            {Math.abs(
                                              item?.diff_time?.timeValue
                                            )}{" "}
                                            {item?.diff_time?.timeType}{" "}
                                            {item?.actual_time?.timeValue <
                                            item?.estimated_time?.timeValue
                                              ? "Less"
                                              : "More"}
                                          </>
                                        ) : (
                                          <>{appContent?.KEY270}</>
                                        )}
                                      </Typography>
                                    </>
                                  )}
                                </Box>
                              )}
                            </Box>

                            <Stack width='22%' direction="column" spacing={1}>
                              {item?.type === MessageType?.Approval && (
                                <>
                                  {(item?.from?.id ===
                                    currentUserData?.id ||
                                    item?.assignee?.id ===
                                      currentUserData?.id) &&
                                    item?.approval_status !==
                                      ApprovalStatus?.Approved &&
                                    item?.approval_status !==
                                      ApprovalStatus?.Rejected &&
                                    item?.approval_status !==
                                      ApprovalStatus?.Cancelled && (
                                      <Stack
                                        direction="row"
                                        sx={{
                                          ...classes.pendingT,
                                          cursor: "pointer",
                                          padding: "0.5rem 0.5rem",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          border: "1px solid #000000",
                                        }}
                                        color={"#fff"}
                                        // bgcolor={"#DB0011"}
                                        onClick={() =>
                                          handleClickTaskUpdate(item)
                                        }
                                      >
                                        <Typography
                                          sx={{
                                            ...classes.txt,
                                            color: colorSchemes.black,
                                          }}
                                        >
                                          {" "}
                                          Update{" "}
                                        </Typography>
                                      </Stack>
                                    )}
                                </>
                              )}
                              {item?.type === MessageType?.Task && (
                                <>
                                  {/* <Box
                                    display={"flex"}
                                    sx={{
                                      ...classes.pendingT,
                                      cursor: "pointer",
                                      padding: "0.5rem 0.5rem",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                    color={"#fff"}

                                    
                                  >
                                    <Box display={"flex"} alignItems={"center"}>
                                    
                                    </Box>
                                    <Typography sx={classes.txt}>
                                      {" "}
                                      {taskStatusLabels[item?.task_status]}{" "}
                                    </Typography>
                                  </Box> */}

                                  {item?.assignee?.id ===
                                    currentUserData?.id &&
                                    (item?.task_status ===
                                      TaskStatus?.Pending ||
                                      item?.task_status ===
                                        TaskStatus?.Delayed) && (
                                      <Stack
                                        direction="row"
                                        position={"relative"}
                                        sx={{
                                          ...classes.pendingT,
                                          cursor: "pointer",
                                          padding: "0.5rem 0.5rem",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          border: "1px solid #000000",
                                        }}
                                        color={"#fff"}
                                        //bgcolor={"#fff"}
                                        onClick={() => handleStartTask(item)}
                                      >
                                        {startTaskOpen?.timetoken ===
                                          item?.timetoken && (
                                          <StartTask
                                            open={
                                              startTaskOpen?.timetoken ===
                                              item?.timetoken
                                            }
                                            taskData={item}
                                            setStartTaskOpen={setStartTaskOpen}
                                          />
                                        )}
                                        {/* <Box
                                          display={"flex"}
                                          alignItems={"center"}
                                        >
                                          <TaskSvg
                                            circleColor={"#fff"}
                                            tickColor={"#fff"}
                                          />
                                        </Box> */}
                                        <Typography sx={classes.txt}>
                                          {" "}
                                          Start task{" "}
                                        </Typography>
                                      </Stack>
                                    )}
                                  {(showUpdateTaskButton(currentUserData,item,groupRecipientDetails)) && (
                                    <Stack
                                      direction="row"
                                      sx={{
                                        ...classes.pendingT,
                                        cursor: "pointer",
                                        padding: "0.5rem 0.5rem",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        border: "1px solid #000000",
                                      }}
                                      color={"#fff"}
                                      bgcolor={"#fff"}
                                      onClick={() =>
                                        handleClickTaskUpdate(item)
                                      }
                                    >
                                      <Typography
                                        sx={{
                                          ...classes.txt,
                                          color: colorSchemes.black,
                                        }}
                                      >
                                        {" "}
                                        Update{" "}
                                      </Typography>
                                    </Stack>
                                  )}
                                </>
                              )}
                            </Stack>
                          </Box>
                        </>
                      )}

                      {/* -----------------Attachments------------------ */}
                      {item?.attachments?.length > 0 && (
                        <Box mt={"0.5rem"}>
                          {item?.attachments?.map((fileData) => {
                            const fileIconOrType = getFileIconUrl(fileData?.location);
                            const isAudio = fileIconOrType === "audio";
                            return (
                            <Box key={fileData?.location} mt={"0.5rem"}>
                              {isAudio ? (
                                <SignedAudioPlayer location={fileData?.location} />
                              ) : (
                              <Box
                                sx={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (isGoogleYoutubeUrl(fileData?.location)) {
                                    window.open(fileData?.location, "_blank");
                                  } else {
                                    handleOpenFile(dispatch, fileData, handleMediaDownload);
                                  }
                                }}
                              >
                                <Box
                                  display={"flex"}
                                  alignItems={"center"}
                                  gap={"0.2rem"}
                                >
                                  <img
                                    style={{ height: "25px", width: "25px" }}
                                    src={fileIconOrType}
                                    alt={fileData?.name}
                                  />
                                  <Typography
                                    variant="subtitle2"
                                    fontWeight={"400"}
                                    fontSize={"0.75rem"}
                                  >
                                    {fileData?.name}
                                  </Typography>
                                  {onPreviewFile && (
                                    <IconButton
                                      size="small"
                                      title="Preview"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        onPreviewFile(fileData);
                                      }}
                                      sx={{ padding: "2px" }}
                                    >
                                      <VisibilityOutlinedIcon sx={{ fontSize: "1rem" }} />
                                    </IconButton>
                                  )}
                                </Box>
                              </Box>
                              )}
                            </Box>
                            );
                          })}
                        </Box>
                      )}

                    </Box>
                  </Stack>
                </div>
              </Stack>
            </>
          )}
        </Box>
      </Box>
    </>
  );
};

export default MessageThread;
